import { Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import Details from './Details';
import { IDetailsWrapper } from './types';

const DetailsWrapper = (props: IDetailsWrapper) => {
  const { title, detailsProps, defaultStyle, marginLeft } = props;
  return (
    <>
      <Box display='flex'
        flexWrap='wrap' minWidth={200}
        sx={{
          marginLeft: marginLeft
            ? '10px'
            : '0px',
          marginTop: defaultStyle
            ? '0px'
            : '24px'}} >
        <Paper variant='outlined' 
          sx={{ height: 'fit-content', borderRadius: 2, boxShadow: 0, backgroundColor: 'transparent'}}>
          {title
            ? <Typography m={2} variant='h3'>{title}</Typography>
            : null
          }
          <Box m={1}>
            <Details
              {...detailsProps}
            /> 
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default DetailsWrapper;